<div class="grouping">
    <div class="main-wrapper">
        <columns-settings [addFieldLabel]="'Add Subgroup'" [columns]="groupColumns" [tabSettings]="tabSettings" (orderChanged)="setGroupField()" [selectedView]="selectedView"
            (fieldChanged)="setGroupField()">
        </columns-settings>
    </div>
</div>
